import React from 'react'
import MuiButtonGroup, { ButtonGroupProps } from '@mui/material/ButtonGroup'

export const ButtonGroup = <C extends React.ElementType='div'>(props: ButtonGroupProps<C, { component?: C }>) => <MuiButtonGroup {...props} />

export default ButtonGroup
